import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  name: "used-category",
  data: function data() {
    return {
      searchForm: {},
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据

      // 表单
      form: {
        categoryId: "",
        weight: ""
      },
      dialogVisible: false,
      // 弹窗状态

      categoryList: [],
      // 分类列表

      currentRow: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getUsedCategoryList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getUsedCategoryList: function getUsedCategoryList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getUsedCategoryList();
            case 1:
              res = _context2.v;
              _this2.categoryList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateSort: function updateSort(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.saveUsedAds(row);
            case 1:
              _this3.$message.success("操作成功");
              _this3.getData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getData: function getData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getUsedAdsList();
            case 1:
              res = _context4.v;
              console.log(res);
              _this4.tableData = res.data || [];
              _this4.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.saveUsedAds(_this5.form);
            case 1:
              _this5.dialogVisible = false;
              _this5.form = {};
              _this5.getData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.deleteUsedAds({
                id: row.id
              });
            case 1:
              _this6.$message.success("操作成功");
              _this6.getData();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))).catch(function () {});
    }
  }
};